import React, { useState, useEffect, useRef, createContext, useContext } from 'react';
import dataProvider from '../../lib/dataProvider';
import { apiPath } from '../../lib/isTest';
import MultiInput from '../../lib/rep/MultiInput';
import { CheckRecht, getInfoValue, getGlobalData } from '../../lib/globalData';
import { useTranslate } from 'react-admin';

import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CardContent from '@mui/material/CardContent';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import 'moment/dist/locale/de';

const ParamContext = createContext();

const ParamProvider = ({ children }) => {
  const [params, setParams] = useState('');
  const [data, setData] = useState({id_lang: getInfoValue('id_sprache'), id_report: 0, startDate: moment().startOf('month').format('YYYY-MM-DD'), endDate: moment().endOf('month').format('YYYY-MM-DD'), params: [], reports: []});

  return (
    <ParamContext.Provider value={{ params, setParams, data, setData }}>
      {children}
    </ParamContext.Provider>
  );
};

const UrlField = ({ title, type }) => {
  const { params, data } = useContext(ParamContext)
  const formEl = useRef(null);
  const token = getGlobalData('token');
  const doReport = (ev) => {
    formEl.current.submit();
  }
  return (
    <>
      <Button onClick={doReport} variant="contained" sx={{ textDecoration: 'none', width: '14em' }}>
        {title}
      </Button>
      <form method="post" action={apiPath+"v1/repReport/gen"} ref={formEl} target="_blank">
        <input type="hidden" name="token" value={token} />
        <input type="hidden" name="type" value={type} />
        <input type="hidden" name="id_lang" value={data.id_lang} />
        <input type="hidden" name="id_report" value={data.id_report} />
        <input type="hidden" name="startDate" value={data.startDate} />
        <input type="hidden" name="endDate" value={data.endDate} />
        <input type="hidden" name="params" value={params} />
        <input type="hidden" name="id" value={0} />
      </form>
    </>
  )
}

const ReportForm = () => {
  const tr = useTranslate();
  const { setParams, data, setData } = useContext(ParamContext)
  const [startDate, setStartDate] = useState(moment())
  const [endDate, setEndDate] = useState(moment().add(1, 'month'))

  moment.locale('de');

  const updateData = (data) => {
    if(data){
      setData(data)
      setParams( JSON.stringify(data.params.values) )
    }
  }

  useEffect(() => {
    dataProvider.update('repReport', {id:0, data: data })
    .then(res  => {
      updateData(res.data)
    })
    // eslint-disable-next-line
  }, []);

  const reloadData = (updData) => {
    dataProvider.update('repReport', {id:0, data: {...data, ...updData} })
    .then(res  => {
      updateData(res.data)
    })
  }

  const storeData = (updData) => {
    updateData({...data, ...updData})
  }

  
  //console.log(["rerender", startDate.format('YYYY-MM-DD h:mm:s'), endDate.format('YYYY-MM-DD h:mm:s')])
  
  return (        
    <Paper style={{scroll:'auto'}} >
      <CardContent>
      <div style={{ marginTop: '1em'}}>
        <div style={{ marginLeft: '0.3em', fontSize: '0.9em', color: 'grey' }}>{tr('bw.rep.report.language')}</div>
        <Select value={data.id_lang} onChange={(ev) => {reloadData({ id_lang: ev.target.value} ) }} size="small" sx={{width: '15em'}} >
          <MenuItem value={1}>Deutsch</MenuItem>
          <MenuItem value={2}>English</MenuItem>
          <MenuItem value={3}>Français</MenuItem>
        </Select>
      </div>
      
      <div style={{ marginTop: '1em'}}>
        <div style={{ marginLeft: '0.3em', fontSize: '0.9em', color: 'grey' }}>{tr('bw.rep.report.reportType')}</div>
        <Select value={data?.id_report} onChange={(ev) => {reloadData({ id_report: ev.target.value}) }} size="small" sx={{width: '20em'}}>
          { data.reports.map((el) => <MenuItem key={el.id} value={el.id}>{el.bez}</MenuItem>) }
        </Select>
      </div>
      
      <div style={{ marginTop: '1em'}}>
        { data.params.fields && data.params.fields.map((el) =><MultiInput key={el.name} source={el.name} updateData={updateData} ParamContext={ParamContext} />)}
      </div>

      <div style={{ marginTop: '1em', display:'flex', justifyContent: 'flex-start', paddingBottom: '1em'}}>
        <LocalizationProvider dateAdapter={AdapterMoment} >
          <>
          <div>
            <div style={{ marginLeft: '.3em', fontSize: '0.9em', color: 'grey' }}>{tr('bw.rep.report.startDate')}</div>
            <DatePicker label='' value={startDate}
              onChange={(ev) => {setStartDate(ev); storeData({ startDate: ev.format('YYYY-MM-DD')})} }
              sx={{mt: 0, mb: 0, width: '12.3em',
              '& .MuiInputBase-root': { height: '40px', padding: '0 14px' },
              '& .MuiFilledInput-input': { padding: '0 0px', fontSize: '1.2em' },
              '& .MuiInput-underline:before': { borderBottom: 'none' },
              '& .MuiInput-underline:after': { borderBottom: 'none' },
              '& .MuiInput-underline': { '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' }}, }}
            />
          </div>
          { (data?.showEndDate?true:false) && <div>
            <div style={{ marginLeft: '1.3em', fontSize: '0.9em', color: 'grey' }}>{tr('bw.rep.report.endDate')}</div>
            <DatePicker label='' value={endDate}
              onChange={(ev) => {setEndDate(ev); storeData({ endDate: ev.format('YYYY-MM-DD')})}}
              sx={{mt: 0, mb: 0, ml: '1em', width: '12.3em',
              '& .MuiInputBase-root': { height: '40px', padding: '0 14px' },
              '& .MuiFilledInput-input': { padding: '0 0px', fontSize: '1.2em' },
              '& .MuiInput-underline:before': { borderBottom: 'none' },
              '& .MuiInput-underline:after': { borderBottom: 'none' },
              '& .MuiInput-underline': { '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' }}, }}
            />
          </div> }
          </>
        </LocalizationProvider>
      </div>
      
      <div style={{display:'flex', justifyContent: 'space-between', flexDirection: 'column', gap: '1em'}}>
        <div style={{display:'flex', justifyContent: 'flex-start', gap: '1em'}}>
          <Button variant="outlined" color="primary" value="-1d" 
            onClick={()=>{
              storeData({ 
                startDate: moment(startDate).subtract(1, 'day').format('YYYY-MM-DD'), 
                endDate: moment(endDate).subtract(1, 'day').format('YYYY-MM-DD'), 
              });
              setStartDate(moment(startDate).subtract(1, 'day'));
              setEndDate(moment(endDate).subtract(1, 'day'));
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.oneDayBack')}
          </Button>
          <Button variant="outlined" color="primary" value="today" 
            onClick={()=>{
              storeData({ 
                startDate: moment().format('YYYY-MM-DD'), 
                endDate: moment().format('YYYY-MM-DD'), 
              });
              setStartDate(moment());
              setEndDate(moment());
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.today')}
          </Button>
          <Button variant="outlined" color="primary" value="+1d" 
            onClick={()=>{
              storeData({ 
                startDate: moment(startDate).add(1, 'day').format('YYYY-MM-DD'), 
                endDate: moment(endDate).add(1, 'day').format('YYYY-MM-DD'), 
              });
              setStartDate(moment(startDate).add(1, 'day'));
              setEndDate(moment(endDate).add(1, 'day'));
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.addOneDay')}
          </Button>
        </div>

        <div style={{display:'flex', justifyContent: 'flex-start', gap: '1em'}}>
          <Button variant="outlined" color="primary" value="-1m" 
            onClick={()=>{
              var ed = moment(endDate).isSame(moment(endDate).clone().endOf('month'), 'day')?moment(endDate).subtract(1, 'month').endOf('month'):moment(endDate).subtract(1, 'month');
              storeData({ 
                startDate: moment(startDate).subtract(1, 'month').format('YYYY-MM-DD'), 
                endDate: ed.format('YYYY-MM-DD'), 
              });
              setStartDate(moment(startDate).subtract(1, 'month'));
              setEndDate(ed);
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.oneMonthBack')}
          </Button>
          <Button variant="outlined" color="primary" value="thisMonth" 
            onClick={()=>{
              storeData({ 
                startDate: moment().startOf('month').format('YYYY-MM-DD'), 
                endDate: moment().endOf('month').format('YYYY-MM-DD'), 
              });
              setStartDate(moment().startOf('month'));
              setEndDate(moment().endOf('month'));
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.thisMonth')}
          </Button>
          <Button variant="outlined" color="primary" value="+1m" 
            onClick={()=>{
              var ed = moment(endDate).isSame(moment(endDate).clone().endOf('month'), 'day')?moment(endDate).add(1, 'month').endOf('month'):moment(endDate).add(1, 'month');
              storeData({ 
                startDate: moment(startDate).add(1, 'month').format('YYYY-MM-DD'), 
                endDate: ed.format('YYYY-MM-DD'), 
              });
              setStartDate(moment(startDate).add(1, 'month'));
              setEndDate(ed);
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.addOneMonth')}
          </Button>
        </div>

        <div style={{display:'flex', justifyContent: 'flex-start', gap: '1em'}}>
          <Button variant="outlined" color="primary" value="-1y" 
            onClick={()=>{
              storeData({ 
                startDate: moment(startDate).subtract(1, 'year').format('YYYY-MM-DD'), 
                endDate: moment(endDate).subtract(1, 'year').format('YYYY-MM-DD'), 
              });
              setStartDate(moment(startDate).subtract(1, 'year'));
              setEndDate(moment(endDate).subtract(1, 'year'));
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.oneYearBack')}
          </Button>
          <Button variant="outlined" color="primary" value="thisYear" 
            onClick={()=>{
              storeData({ 
                startDate: moment().startOf('year').format('YYYY-MM-DD'), 
                endDate: moment().endOf('year').format('YYYY-MM-DD'), 
              });
              setStartDate(moment().startOf('year'));
              setEndDate(moment().endOf('year'));
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.thisYear')}
          </Button>
          <Button variant="outlined" color="primary" value="+1y" 
            onClick={()=>{
              storeData({ 
                startDate: moment(startDate).add(1, 'year').format('YYYY-MM-DD'), 
                endDate: moment(endDate).add(1, 'year').format('YYYY-MM-DD'), 
              });
              setStartDate(moment(startDate).add(1, 'year'));
              setEndDate(moment(endDate).add(1, 'year'));
            }} 
            style={{width: '14em'}}>
            {tr('bw.rep.report.addOneYear')}
          </Button>
        </div>
      </div>

      <div style={{marginTop: '2em', display:'flex', justifyContent: 'space-between', flexDirection: 'column', gap: '1em'}}>
        <div style={{display:'flex', justifyContent: 'flex-start', gap: '0.5em'}}>
          { !data.noPdf && <UrlField title='Create PDF' type='pdf' /> }
          { !data.noExcel && <UrlField title='Create Exel' type='xls' /> }
          { !data.noCsv && <UrlField title='Create CSV' type='csv' /> }
        </div>
        <div style={{display:'flex', justifyContent: 'flex-start', gap: '0.5em'}}>
          <CheckRecht route='repReport' level={9}>
            <UrlField title='SQL' type='sql' /> 
            <UrlField title='Json' type='json' />
          </CheckRecht>
        </div>
      </div>
      </CardContent>
    </Paper>         
  )
}

const RepReport = () => (
  <ParamProvider>
    <ReportForm />
  </ParamProvider> 
)

export default RepReport;